let searchByGeo = {

    props: {
        searchByGeo: Number,
        searchByGeoRange: Number
    },
    computed: {

    },
    components: {

    },
    directives: {

    },
    data() {
        return {

        }
    },
    methods: {
        searchbygeoevent() {
            this.$root.callfilters(event)
        },
        searchbygeorangevent() {
            this.$root.callfilters(event)
        },
        clickSearchByGeo() {
            this.searchByGeo = (this.searchByGeo == 1) ? 0 : 1;
        },
    },
    template: `
    <div class="filter-block dropright">
        <h4 @click="clickSearchByGeo" id="searchByGeoButton" rel="2" class="text-center" :class="{'selected':searchByGeo}"><i class="fad fa-location"></i></h4>
        <input @change="searchbygeoevent" type="hidden" class="searchByGeo" id="critereSearchByGeo" name="searchByGeo" :value="searchByGeo" checked="searchByGeo ? 'checked' : false">
        <div id="searchByGeoRangeWrapper" class="range-slider" v-show="searchByGeo">
            <input @change="searchbygeorangevent" type="range" id="searchByGeoRange" class="searchByGeoRange range-slider__range" name="searchByGeoRange" :value="searchByGeoRange" min="100" max="5000">
            <span class="range-slider__value">{{ searchByGeoRange }}</span>
        </div>
    </div>
    `
}